var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedCommentWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99988 16C13.4182 16 16.9999 12.4183 16.9999 8C16.9999 3.58172 13.4182 0 8.99988 0C4.58161 0 0.999885 3.58172 0.999885 8C0.999885 9.43769 1.37913 10.7868 2.04303 11.9528L0.597168 15.6788L4.21016 14.4083C5.54545 15.4079 7.20353 16 8.99988 16ZM8.08008 6.91687C8.08008 7.42104 8.49258 7.83354 8.99674 7.83354C9.50091 7.83354 9.91341 7.42104 9.91341 6.91687V5.08354C9.91341 4.57937 9.50091 4.16687 8.99674 4.16687C8.49258 4.16687 8.08008 4.57937 8.08008 5.08354V6.91687ZM8.08008 11.5002H9.91341V9.66687H8.08008V11.5002Z",
    fill: "#F9C475"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedCommentWarningIcon);
export default __webpack_public_path__ + "static/media/DeprecatedCommentWarningIcon.2cc9c6a86cecfb44afc2b6fa7ce57518.svg";
export { ForwardRef as ReactComponent };